export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const MOVIE_FILE_START = 'MOVIE_FILE_START';
export const MOVIE_FILE_SUCCESS = 'MOVIE_FILE_SUCCESS';
export const MOVIE_FILE_FAILURE = 'MOVIE_FILE_FAILURE';

export const TEXT_FILE_START = 'TEXT_FILE_START';
export const TEXT_FILE_SUCCESS = 'TEXT_FILE_SUCCESS';
export const TEXT_FILE_FAILURE = 'TEXT_FILE_FAILURE';

export const REC_FILE_START = 'REC_FILE_START';
export const REC_FILE_SUCCESS = 'REC_FILE_SUCCESS';
export const REC_FILE_FAILURE = 'REC_FILE_FAILURE';

export const PRIVILEGE_ID_LENDING_RECORDS_START = 'PRIVILEGE_ID_LENDING_RECORDS_START';
export const PRIVILEGE_ID_LENDING_RECORDS_SUCCESS = 'PRIVILEGE_ID_LENDING_RECORDS_SUCCESS';
export const PRIVILEGE_ID_LENDING_RECORDS_FAILURE = 'PRIVILEGE_ID_LENDING_RECORDS_FAILURE';

export const ROUTINE_WORK_START = 'ROUTINE_WORK_START';
export const ROUTINE_WORK_SUCCESS = 'ROUTINE_WORK_SUCCESS';
export const ROUTINE_WORK_FAILURE = 'ROUTINE_WORK_FAILURE';

export const REC_FILE_DOWNLOAD_START = 'REC_FILE_DOWNLOAD_START';
export const REC_FILE_DOWNLOAD_SUCCESS = 'REC_FILE_DOWNLOAD_SUCCESS';
export const REC_FILE_DOWNLOAD_FAILURE = 'REC_FILE_DOWNLOAD_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
export const CLEAR_LENDING_RECORDS_ERROR = 'CLEAR_LENDING_RECORDS_ERROR';

export const COMMENT_START = 'COMMENT_START';
export const COMMENT_SUCCESS = 'COMMENT_SUCCESS';
export const COMMENT_FAILURE = 'COMMENT_FAILURE';

export const DISPLAYABLE_START = 'DISPLAYABLE_START';
export const DISPLAYABLE_SUCCESS = 'DISPLAYABLE_SUCCESS';
export const DISPLAYABLE_FAILURE = 'DISPLAYABLE_FAILURE';

export const REGISTER_LOGIN_START = 'REGISTER_LOGIN_START';
export const REGISTER_LOGIN_SUCCESS = 'REGISTER_LOGIN_SUCCESS';
export const REGISTER_LOGIN_FAILURE = 'REGISTER_LOGIN_FAILURE';
